import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable, of, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GroupsService
 {
    constructor(private http: HttpClient) { }
    urlEndPoint = environment.endPoint + "/api/groups/";

      

    getProperties(groupType, id: number){
      return this.http.get<any>(this.urlEndPoint + `${groupType}/${id}/properties`);
    }    

    getWards(groupType: string, groupId): Observable<any> {
        return this.http.get<any>(this.urlEndPoint + `${groupType}/${groupId}/wards`)       
    }
  

}